import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Fa from 'react-fontawesome';
import {
  filter, indexOf,
 } from 'lodash';
import {
  FormGroup, ControlLabel, FormControl,
  Tab, Tabs,
} from 'react-bootstrap';
import WindowResizeListener from '../../../../components/window-size-listener';
import MoneyDisplay from '../../../../components/money-display';
import NumberDisplay from '../../../../components/number-display';
import ContactTable from './ContactTable';
import { reverseTranslateOutcome } from '../../../../util/truvoice';

class Log extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: props.isAccount ? 'account' : 'opportunity',
      contactContainerWidth: 0,
    };
    this.onWindowResize = this.onWindowResize.bind(this);
    this.handleTabSelect = this.handleTabSelect.bind(this);
  }

  onWindowResize() {
    if (this.contactContainer) {
      this.setState({ contactContainerWidth: this.contactContainer.offsetWidth });
    }
  }
  handleTabSelect(tab) {
    this.setState({ tab });
  }

  renderOpportunityTab() {
    const { log } = this.props;
    const opportunity = log;
    const { owner, outcome } = opportunity;
    const closeDate = opportunity.close_date;
    const closeDateStr = closeDate ? moment(closeDate).format('MMM DD, YYYY') : null;

    return (
      <Tab eventKey="opportunity" title="Opportunity">
        <div>
          <p />
          <div className="row">
            <div className="col-sm-12">
              <FormGroup>
                <ControlLabel>Opportunity Name</ControlLabel>
                <FormControl type="text" disabled readOnly value={opportunity.name} />
              </FormGroup>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <FormGroup>
                <ControlLabel>Opportunity Size</ControlLabel>
                <div type="text" className="form-control" disabled readOnly style={{ lineHeight: '2.5em' }}>
                  <MoneyDisplay value={opportunity.amount} />
                </div>
              </FormGroup>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <FormGroup>
                <ControlLabel>Close Date</ControlLabel>
                <FormControl type="text" disabled readOnly value={closeDateStr || 'N/A'} />
              </FormGroup>
            </div>
            <div className="col-sm-6">
              <FormGroup>
                <ControlLabel>Outcome</ControlLabel>
                <FormControl type="text" disabled readOnly value={reverseTranslateOutcome(outcome)} />
              </FormGroup>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <FormGroup>
                <ControlLabel>Opportunity Owner</ControlLabel>
                <FormControl type="text" disabled readOnly value={owner ? `${owner.first_name} ${owner.last_name}` : 'N/A'} />
              </FormGroup>
            </div>
          </div>
        </div>
      </Tab>
    );
  }

  renderAccountTab() {
    const { log } = this.props;
    const account = log.account || log;
    if (!account) {
      return null;
    }
    return (
      <Tab eventKey="account" title="Account">
        <div>
          <p />
          <div className="row">
            <div className="col-sm-12">
              <FormGroup>
                <ControlLabel>Account Name</ControlLabel>
                <FormControl type="text" disabled readOnly value={account.name} />
              </FormGroup>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <FormGroup>
                <ControlLabel>Annual Revenue</ControlLabel>
                <div type="text" className="form-control" disabled readOnly style={{ lineHeight: '2.5em' }}>
                  <MoneyDisplay value={account.annual_revenue} />
                </div>
              </FormGroup>
            </div>
            <div className="col-sm-6">
              <FormGroup>
                <ControlLabel>Number of Employees</ControlLabel>
                <div type="text" className="form-control" disabled readOnly style={{ lineHeight: '2.5em' }}>
                  <NumberDisplay value={account.number_of_employees} precision={0} />
                </div>
              </FormGroup>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <FormGroup>
                <ControlLabel>Industry</ControlLabel>
                <FormControl type="text" disabled readOnly value={(account.industry || 'N/A')} />
              </FormGroup>
            </div>
            <div className="col-sm-6">
              <FormGroup>
                <ControlLabel>Phone</ControlLabel>
                <FormControl type="text" disabled readOnly value={(account.phone || 'N/A')} />
              </FormGroup>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <FormGroup>
                <ControlLabel>Website</ControlLabel>
                <FormControl type="text" disabled readOnly value={(account.website || 'N/A')} />
              </FormGroup>
            </div>
          </div>
        </div>
      </Tab>
    );
  }
  renderContactTab() {
    const { log, program } = this.props;
    const contacts = log.selected_contacts || [];
    const active = this.state.tab === 'contacts';

    return (
      <Tab eventKey="contacts" title={<span>Contacts <span className="badge">{contacts.length}</span></span>}>
        <div>
          <p />
          {active &&
            <ContactTable
              width={this.state.contactContainerWidth}
              contacts={contacts}
              program={program}
            />
          }
        </div>
      </Tab>
    );
  }
  renderProductTab() {
    const { program, log } = this.props;
    const products = program && program.initiatives && program.initiatives.products ? program.initiatives.products : [];
    const selectedId = log.selected_product_ids || [];
    const selectedProducts = filter(products, (product) => {
      return indexOf(selectedId, product.id) >= 0;
    });
    return (
      <Tab eventKey="products" title={<span>Products <span className="badge">{selectedProducts.length}</span></span>}>
        <div>
          <p />
          {selectedProducts.length > 0 &&
            <table className="table table-condensed table-striped">
              <tbody>
                {selectedProducts.map((product) => {
                  return (
                    <tr key={product.id}>
                      <td width="30" className="text-center"><Fa name="check-square-o" className="text-success" /></td>
                      <td>{product.name}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          }
          {selectedProducts.length === 0 && <div>No records found</div>}
        </div>
      </Tab>
    );
  }
  renderOtherTab() {
    const { log, isAccount } = this.props;
    const label1 = isAccount ? 'Account Questions' : 'Opportunity Questions';
    const label2 = isAccount ? 'Additional Account Information' : 'Additional Opportunity Information';

    return (
      <Tab eventKey="other" title="Other">
        <div>
          <p />
          <div className="row">
            <div className="col-sm-12">
              <FormGroup>
                <ControlLabel>{label1}</ControlLabel>
                <FormControl componentClass="textarea" disabled readOnly value={(log.question || 'N/A')} />
              </FormGroup>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <FormGroup>
                <ControlLabel>{label2}</ControlLabel>
                <FormControl componentClass="textarea" disabled readOnly value={(log.additional_information || 'N/A')} />
              </FormGroup>
            </div>
          </div>
          {log.user !== undefined && log.user !== null &&
            <div className="row">
              <div className="col-sm-12">
                <FormGroup>
                  <ControlLabel>Submitted by</ControlLabel>
                  <FormControl type="text" disabled readOnly value={log.user.display_name} />
                </FormGroup>
              </div>
            </div>
          }
        </div>
      </Tab>
    );
  }

  render() {
    const { isAccount, log } = this.props;
    return (
      <div>
        <Tabs
          id={`log-tabs-${log._id}`}
          defaultActiveKey={isAccount ? 'account' : 'opportunity'}
          onSelect={this.handleTabSelect}
          activeKey={this.state.tab}
          mountOnEnter
        >
          {!isAccount && this.renderOpportunityTab()}
          {this.renderAccountTab()}
          {this.renderContactTab()}
          {this.renderProductTab()}
          {this.renderOtherTab()}
        </Tabs>
        <div ref={(el) => { this.contactContainer = el; }}>
          <p />
          <WindowResizeListener onResize={this.onWindowResize} />
        </div>
      </div>
    );
  }
}

Log.propTypes = {
  log: PropTypes.shape({
    owner: PropTypes.shape({}),
  }).isRequired,
  isAccount: PropTypes.bool.isRequired,
  program: PropTypes.shape({}).isRequired,
};
Log.defaultProps = {
};

export default Log;
